import Vue from 'vue'
import Zendesk from '@dansmaculotte/vue-zendesk'

const KEY = 'c5e3e3fb-364e-4ef5-99d5-05f7fe38860c'
const DISABLED = false
const HIDE_ON_LOAD = false
const SETTINGS = {"webWidget":{"zIndex":100}}

export default function (context) {
  Vue.use(Zendesk, {
    key: KEY,
    disabled: DISABLED,
    hideOnLoad: HIDE_ON_LOAD,
    settings: SETTINGS
  })
}
